var _asyncToGenerator = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/regenerator");

var _wrapAsyncGenerator = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _awaitAsyncGenerator = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _asyncIterator = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/asyncIterator");

var _asyncGeneratorDelegate = require("/home/runner/work/d-simple-website/d-simple-website/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

/* replacement start */
var process = require('process/')
/* replacement end */
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
;

'use strict';

var _require = require('../../ours/primordials'),
    ArrayIsArray = _require.ArrayIsArray,
    Promise = _require.Promise,
    SymbolAsyncIterator = _require.SymbolAsyncIterator,
    SymbolDispose = _require.SymbolDispose;

var eos = require('./end-of-stream');

var _require2 = require('../../ours/util'),
    once = _require2.once;

var destroyImpl = require('./destroy');

var Duplex = require('./duplex');

var _require3 = require('../../ours/errors'),
    aggregateTwoErrors = _require3.aggregateTwoErrors,
    _require3$codes = _require3.codes,
    ERR_INVALID_ARG_TYPE = _require3$codes.ERR_INVALID_ARG_TYPE,
    ERR_INVALID_RETURN_VALUE = _require3$codes.ERR_INVALID_RETURN_VALUE,
    ERR_MISSING_ARGS = _require3$codes.ERR_MISSING_ARGS,
    ERR_STREAM_DESTROYED = _require3$codes.ERR_STREAM_DESTROYED,
    ERR_STREAM_PREMATURE_CLOSE = _require3$codes.ERR_STREAM_PREMATURE_CLOSE,
    AbortError = _require3.AbortError;

var _require4 = require('../validators'),
    validateFunction = _require4.validateFunction,
    validateAbortSignal = _require4.validateAbortSignal;

var _require5 = require('./utils'),
    isIterable = _require5.isIterable,
    isReadable = _require5.isReadable,
    isReadableNodeStream = _require5.isReadableNodeStream,
    isNodeStream = _require5.isNodeStream,
    isTransformStream = _require5.isTransformStream,
    isWebStream = _require5.isWebStream,
    isReadableStream = _require5.isReadableStream,
    isReadableFinished = _require5.isReadableFinished;

var AbortController = globalThis.AbortController || require('abort-controller').AbortController;

var PassThrough;
var Readable;
var addAbortListener;

function destroyer(stream, reading, writing) {
  var finished = false;
  stream.on('close', function () {
    finished = true;
  });
  var cleanup = eos(stream, {
    readable: reading,
    writable: writing
  }, function (err) {
    finished = !err;
  });
  return {
    destroy: function destroy(err) {
      if (finished) return;
      finished = true;
      destroyImpl.destroyer(stream, err || new ERR_STREAM_DESTROYED('pipe'));
    },
    cleanup: cleanup
  };
}

function popCallback(streams) {
  // Streams should never be an empty array. It should always contain at least
  // a single stream. Therefore optimize for the average case instead of
  // checking for length === 0 as well.
  validateFunction(streams[streams.length - 1], 'streams[stream.length - 1]');
  return streams.pop();
}

function makeAsyncIterable(val) {
  if (isIterable(val)) {
    return val;
  } else if (isReadableNodeStream(val)) {
    // Legacy streams are not Iterable.
    return fromReadable(val);
  }

  throw new ERR_INVALID_ARG_TYPE('val', ['Readable', 'Iterable', 'AsyncIterable'], val);
}

function fromReadable(_x) {
  return _fromReadable.apply(this, arguments);
}

function _fromReadable() {
  _fromReadable = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(val) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!Readable) {
              Readable = require('./readable');
            }

            return _context.delegateYield(_asyncGeneratorDelegate(_asyncIterator(Readable.prototype[SymbolAsyncIterator].call(val)), _awaitAsyncGenerator), "t0", 2);

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fromReadable.apply(this, arguments);
}

function pumpToNode(_x2, _x3, _x4, _x5) {
  return _pumpToNode.apply(this, arguments);
}

function _pumpToNode() {
  _pumpToNode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(iterable, writable, finish, _ref) {
    var end, error, onresolve, resume, wait, cleanup, _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, chunk;

    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            end = _ref.end;
            onresolve = null;

            resume = function resume(err) {
              if (err) {
                error = err;
              }

              if (onresolve) {
                var callback = onresolve;
                onresolve = null;
                callback();
              }
            };

            wait = function wait() {
              return new Promise(function (resolve, reject) {
                if (error) {
                  reject(error);
                } else {
                  onresolve = function onresolve() {
                    if (error) {
                      reject(error);
                    } else {
                      resolve();
                    }
                  };
                }
              });
            };

            writable.on('drain', resume);
            cleanup = eos(writable, {
              readable: false
            }, resume);
            _context2.prev = 6;

            if (!writable.writableNeedDrain) {
              _context2.next = 10;
              break;
            }

            _context2.next = 10;
            return wait();

          case 10:
            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context2.prev = 12;
            _iterator = _asyncIterator(iterable);

          case 14:
            _context2.next = 16;
            return _iterator.next();

          case 16:
            if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
              _context2.next = 24;
              break;
            }

            chunk = _step.value;

            if (writable.write(chunk)) {
              _context2.next = 21;
              break;
            }

            _context2.next = 21;
            return wait();

          case 21:
            _iteratorAbruptCompletion = false;
            _context2.next = 14;
            break;

          case 24:
            _context2.next = 30;
            break;

          case 26:
            _context2.prev = 26;
            _context2.t0 = _context2["catch"](12);
            _didIteratorError = true;
            _iteratorError = _context2.t0;

          case 30:
            _context2.prev = 30;
            _context2.prev = 31;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context2.next = 35;
              break;
            }

            _context2.next = 35;
            return _iterator.return();

          case 35:
            _context2.prev = 35;

            if (!_didIteratorError) {
              _context2.next = 38;
              break;
            }

            throw _iteratorError;

          case 38:
            return _context2.finish(35);

          case 39:
            return _context2.finish(30);

          case 40:
            if (!end) {
              _context2.next = 44;
              break;
            }

            writable.end();
            _context2.next = 44;
            return wait();

          case 44:
            finish();
            _context2.next = 50;
            break;

          case 47:
            _context2.prev = 47;
            _context2.t1 = _context2["catch"](6);
            finish(error !== _context2.t1 ? aggregateTwoErrors(error, _context2.t1) : _context2.t1);

          case 50:
            _context2.prev = 50;
            cleanup();
            writable.off('drain', resume);
            return _context2.finish(50);

          case 54:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[6, 47, 50, 54], [12, 26, 30, 40], [31,, 35, 39]]);
  }));
  return _pumpToNode.apply(this, arguments);
}

function pumpToWeb(_x6, _x7, _x8, _x9) {
  return _pumpToWeb.apply(this, arguments);
}

function _pumpToWeb() {
  _pumpToWeb = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(readable, writable, finish, _ref2) {
    var end, writer, _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, chunk;

    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            end = _ref2.end;

            if (isTransformStream(writable)) {
              writable = writable.writable;
            } // https://streams.spec.whatwg.org/#example-manual-write-with-backpressure


            writer = writable.getWriter();
            _context3.prev = 3;
            _iteratorAbruptCompletion2 = false;
            _didIteratorError2 = false;
            _context3.prev = 6;
            _iterator2 = _asyncIterator(readable);

          case 8:
            _context3.next = 10;
            return _iterator2.next();

          case 10:
            if (!(_iteratorAbruptCompletion2 = !(_step2 = _context3.sent).done)) {
              _context3.next = 18;
              break;
            }

            chunk = _step2.value;
            _context3.next = 14;
            return writer.ready;

          case 14:
            writer.write(chunk).catch(function () {});

          case 15:
            _iteratorAbruptCompletion2 = false;
            _context3.next = 8;
            break;

          case 18:
            _context3.next = 24;
            break;

          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3["catch"](6);
            _didIteratorError2 = true;
            _iteratorError2 = _context3.t0;

          case 24:
            _context3.prev = 24;
            _context3.prev = 25;

            if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
              _context3.next = 29;
              break;
            }

            _context3.next = 29;
            return _iterator2.return();

          case 29:
            _context3.prev = 29;

            if (!_didIteratorError2) {
              _context3.next = 32;
              break;
            }

            throw _iteratorError2;

          case 32:
            return _context3.finish(29);

          case 33:
            return _context3.finish(24);

          case 34:
            _context3.next = 36;
            return writer.ready;

          case 36:
            if (!end) {
              _context3.next = 39;
              break;
            }

            _context3.next = 39;
            return writer.close();

          case 39:
            finish();
            _context3.next = 53;
            break;

          case 42:
            _context3.prev = 42;
            _context3.t1 = _context3["catch"](3);
            _context3.prev = 44;
            _context3.next = 47;
            return writer.abort(_context3.t1);

          case 47:
            finish(_context3.t1);
            _context3.next = 53;
            break;

          case 50:
            _context3.prev = 50;
            _context3.t2 = _context3["catch"](44);
            finish(_context3.t2);

          case 53:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[3, 42], [6, 20, 24, 34], [25,, 29, 33], [44, 50]]);
  }));
  return _pumpToWeb.apply(this, arguments);
}

function pipeline() {
  for (var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++) {
    streams[_key] = arguments[_key];
  }

  return pipelineImpl(streams, once(popCallback(streams)));
}

function pipelineImpl(streams, callback, opts) {
  if (streams.length === 1 && ArrayIsArray(streams[0])) {
    streams = streams[0];
  }

  if (streams.length < 2) {
    throw new ERR_MISSING_ARGS('streams');
  }

  var ac = new AbortController();
  var signal = ac.signal;
  var outerSignal = opts === null || opts === undefined ? undefined : opts.signal; // Need to cleanup event listeners if last stream is readable
  // https://github.com/nodejs/node/issues/35452

  var lastStreamCleanup = [];
  validateAbortSignal(outerSignal, 'options.signal');

  function abort() {
    finishImpl(new AbortError());
  }

  addAbortListener = addAbortListener || require('../../ours/util').addAbortListener;
  var disposable;

  if (outerSignal) {
    disposable = addAbortListener(outerSignal, abort);
  }

  var error;
  var value;
  var destroys = [];
  var finishCount = 0;

  function finish(err) {
    finishImpl(err, --finishCount === 0);
  }

  function finishImpl(err, final) {
    var _disposable;

    if (err && (!error || error.code === 'ERR_STREAM_PREMATURE_CLOSE')) {
      error = err;
    }

    if (!error && !final) {
      return;
    }

    while (destroys.length) {
      destroys.shift()(error);
    }

    ;
    (_disposable = disposable) === null || _disposable === undefined ? undefined : _disposable[SymbolDispose]();
    ac.abort();

    if (final) {
      if (!error) {
        lastStreamCleanup.forEach(function (fn) {
          return fn();
        });
      }

      process.nextTick(callback, error, value);
    }
  }

  var ret;

  var _loop = function _loop(i) {
    var stream = streams[i];
    var reading = i < streams.length - 1;
    var writing = i > 0;
    var end = reading || (opts === null || opts === undefined ? undefined : opts.end) !== false;
    var isLastStream = i === streams.length - 1;

    if (isNodeStream(stream)) {
      // Catch stream errors that occur after pipe/pump has completed.
      var onError = function onError(err) {
        if (err && err.name !== 'AbortError' && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
          finish(err);
        }
      };

      if (end) {
        var _destroyer = destroyer(stream, reading, writing),
            destroy = _destroyer.destroy,
            cleanup = _destroyer.cleanup;

        destroys.push(destroy);

        if (isReadable(stream) && isLastStream) {
          lastStreamCleanup.push(cleanup);
        }
      }

      stream.on('error', onError);

      if (isReadable(stream) && isLastStream) {
        lastStreamCleanup.push(function () {
          stream.removeListener('error', onError);
        });
      }
    }

    if (i === 0) {
      if (typeof stream === 'function') {
        ret = stream({
          signal: signal
        });

        if (!isIterable(ret)) {
          throw new ERR_INVALID_RETURN_VALUE('Iterable, AsyncIterable or Stream', 'source', ret);
        }
      } else if (isIterable(stream) || isReadableNodeStream(stream) || isTransformStream(stream)) {
        ret = stream;
      } else {
        ret = Duplex.from(stream);
      }
    } else if (typeof stream === 'function') {
      if (isTransformStream(ret)) {
        ret = makeAsyncIterable((_ret = ret) === null || _ret === undefined ? undefined : _ret.readable);
      } else {
        ret = makeAsyncIterable(ret);
      }

      ret = stream(ret, {
        signal: signal
      });

      if (reading) {
        if (!isIterable(ret, true)) {
          throw new ERR_INVALID_RETURN_VALUE('AsyncIterable', "transform[".concat(i - 1, "]"), ret);
        }
      } else {
        if (!PassThrough) {
          PassThrough = require('./passthrough');
        } // If the last argument to pipeline is not a stream
        // we must create a proxy stream so that pipeline(...)
        // always returns a stream which can be further
        // composed through `.pipe(stream)`.


        var pt = new PassThrough({
          objectMode: true
        }); // Handle Promises/A+ spec, `then` could be a getter that throws on
        // second use.

        var then = (_ret2 = ret) === null || _ret2 === undefined ? undefined : _ret2.then;

        if (typeof then === 'function') {
          finishCount++;
          then.call(ret, function (val) {
            value = val;

            if (val != null) {
              pt.write(val);
            }

            if (end) {
              pt.end();
            }

            process.nextTick(finish);
          }, function (err) {
            pt.destroy(err);
            process.nextTick(finish, err);
          });
        } else if (isIterable(ret, true)) {
          finishCount++;
          pumpToNode(ret, pt, finish, {
            end: end
          });
        } else if (isReadableStream(ret) || isTransformStream(ret)) {
          var toRead = ret.readable || ret;
          finishCount++;
          pumpToNode(toRead, pt, finish, {
            end: end
          });
        } else {
          throw new ERR_INVALID_RETURN_VALUE('AsyncIterable or Promise', 'destination', ret);
        }

        ret = pt;

        var _destroyer2 = destroyer(ret, false, true),
            _destroy = _destroyer2.destroy,
            _cleanup = _destroyer2.cleanup;

        destroys.push(_destroy);

        if (isLastStream) {
          lastStreamCleanup.push(_cleanup);
        }
      }
    } else if (isNodeStream(stream)) {
      if (isReadableNodeStream(ret)) {
        finishCount += 2;

        var _cleanup2 = pipe(ret, stream, finish, {
          end: end
        });

        if (isReadable(stream) && isLastStream) {
          lastStreamCleanup.push(_cleanup2);
        }
      } else if (isTransformStream(ret) || isReadableStream(ret)) {
        var _toRead = ret.readable || ret;

        finishCount++;
        pumpToNode(_toRead, stream, finish, {
          end: end
        });
      } else if (isIterable(ret)) {
        finishCount++;
        pumpToNode(ret, stream, finish, {
          end: end
        });
      } else {
        throw new ERR_INVALID_ARG_TYPE('val', ['Readable', 'Iterable', 'AsyncIterable', 'ReadableStream', 'TransformStream'], ret);
      }

      ret = stream;
    } else if (isWebStream(stream)) {
      if (isReadableNodeStream(ret)) {
        finishCount++;
        pumpToWeb(makeAsyncIterable(ret), stream, finish, {
          end: end
        });
      } else if (isReadableStream(ret) || isIterable(ret)) {
        finishCount++;
        pumpToWeb(ret, stream, finish, {
          end: end
        });
      } else if (isTransformStream(ret)) {
        finishCount++;
        pumpToWeb(ret.readable, stream, finish, {
          end: end
        });
      } else {
        throw new ERR_INVALID_ARG_TYPE('val', ['Readable', 'Iterable', 'AsyncIterable', 'ReadableStream', 'TransformStream'], ret);
      }

      ret = stream;
    } else {
      ret = Duplex.from(stream);
    }
  };

  for (var i = 0; i < streams.length; i++) {
    var _ret;

    var _ret2;

    _loop(i);
  }

  if (signal !== null && signal !== undefined && signal.aborted || outerSignal !== null && outerSignal !== undefined && outerSignal.aborted) {
    process.nextTick(abort);
  }

  return ret;
}

function pipe(src, dst, finish, _ref3) {
  var end = _ref3.end;
  var ended = false;
  dst.on('close', function () {
    if (!ended) {
      // Finish if the destination closes before the source has completed.
      finish(new ERR_STREAM_PREMATURE_CLOSE());
    }
  });
  src.pipe(dst, {
    end: false
  }); // If end is true we already will have a listener to end dst.

  if (end) {
    // Compat. Before node v10.12.0 stdio used to throw an error so
    // pipe() did/does not end() stdio destinations.
    // Now they allow it but "secretly" don't close the underlying fd.
    var endFn = function endFn() {
      ended = true;
      dst.end();
    };

    if (isReadableFinished(src)) {
      // End the destination if the source has already ended.
      process.nextTick(endFn);
    } else {
      src.once('end', endFn);
    }
  } else {
    finish();
  }

  eos(src, {
    readable: true,
    writable: false
  }, function (err) {
    var rState = src._readableState;

    if (err && err.code === 'ERR_STREAM_PREMATURE_CLOSE' && rState && rState.ended && !rState.errored && !rState.errorEmitted) {
      // Some readable streams will emit 'close' before 'end'. However, since
      // this is on the readable side 'end' should still be emitted if the
      // stream has been ended and no error emitted. This should be allowed in
      // favor of backwards compatibility. Since the stream is piped to a
      // destination this should not result in any observable difference.
      // We don't need to check if this is a writable premature close since
      // eos will only fail with premature close on the reading side for
      // duplex streams.
      src.once('end', finish).once('error', finish);
    } else {
      finish(err);
    }
  });
  return eos(dst, {
    readable: false,
    writable: true
  }, finish);
}

module.exports = {
  pipelineImpl: pipelineImpl,
  pipeline: pipeline
};